export const Backslash = '\\'
export const Dash = '-'
export const Dot = '.'
export const EmptyString = ''
export const NewLine = '\n'
export const OpenAngleBracket = '<'
export const Slash = '/'
export const Space = ' '
export const Tab = '\t'
export const Underline = '_'
export const T = 't'
